import React, { useState } from "react";
import { Header } from "../../../components/user-dashboard/header";
import { Sidebar } from "../../../components/user-dashboard/sidebar";
import { useNavigate } from "react-router-dom";
import { AdminService } from "../../../app/service/admin.service";
import { toast } from "react-toastify";
import "react-datepicker/dist/react-datepicker.css";
import { courses } from "../../../config";

const CreateBatch = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState<any>({
    courseName: "",
    batchName: "",

  });
  const [errors, setErrors] = useState<any>({});

 

  const handleInput = (e: any) => {
    const { name, value } = e.target;
    setFormData((prevState: any) => ({
      ...prevState,
      [name]: value,
    }));
    setErrors((prevErrors: any) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validate = () => {
    const newErrors: any = {};
    if (!formData.courseName) {
      newErrors.courseName = "Course Name is required";
    }

    if (!formData.batchName) {
      newErrors.batchName = "Batch Name is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();
    if (!validate()) return;

    const payload = {
      courseName: formData.courseName,
      batchName:formData.batchName,
    };

    AdminService.createbatch(payload).then((res) => {
      if (res.status === "Fail") {
        toast.error(res.error);
      } else {
        toast.success(res.message);
        navigate("/support/batchlist");
      }
    });
  };

  const handleCancel = () => {
    navigate("/support/batchlist");
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <Header />
      </div>
      <div className="row">
        <div className="col-md-2 h-100 px-0">
          <Sidebar />
        </div>
        <div className="col-md-10 content-scroll content-bg px-3 py-3">
          <h4 style={{ textAlign: "left" }}>
            <b>Create Batch</b>
          </h4>
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group mt-3">
                  <label className="register-font">Batch Name</label>
                  <input
                    type="text"
                    className={`form-control mt-2 ${
                      errors.batchName ? "is-invalid" : ""
                    }`}
                    placeholder="Batch Name"
                    name="batchName"
                    onChange={handleInput}
                  />
                  {errors.batchName && (
                    <div className="invalid-feedback">{errors.batchName}</div>
                  )}
                </div>
                <div className="form-group mt-3">
                  <label className="register-font">Domain Of Interest</label>
                  <select
                    className={`form-control mt-2 ${
                      errors.courseName ? "is-invalid" : ""
                    }`}
                    onChange={handleInput}
                    name="courseName"
                  >
                    <option>Select Courses</option>
                    {courses.map((ele: any, index) => {
                      return (
                        <option value={ele.name} key={index}>
                          {ele.name}
                        </option>
                      );
                    })}
                  </select>
                  {errors.courseName && (
                    <div className="invalid-feedback">{errors.courseName}</div>
                  )}
                </div>
              </div>
            </div>
            <div className="mt-3">
              <button type="submit" className="btn btn-primary me-2">
                Create
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleCancel}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateBatch;
